/**
 * 二维码登录
 */
import React, { Component } from "react";
import PbAjax from '../../lib/pbajax';
import Cache from 'c-cache';
import publicpb from "../../base/public.pb";
import codeCreatePb from "./codecreate.pb";
import codeQueryPb from "./codequery.pb";
import codeScan from "./codescan.pb";
import qrcode from "../../lib/qrcode";
import lang from "../../lang";

const pbajax = new PbAjax();

const cache = new Cache({
    prefix: 'pcuplive'
});

class QrcodeLogin extends Component {
	static defaultProps = {
		delay: 2 * 1000
	};
	constructor(props) {
		super(props);

		this.state = {
			qrcode: ""
		};
	}

	componentDidMount() {
		let getQrcodePromise = this.getQRCode();

		getQrcodePromise.done(code => {
			this.insertQrcode(code);
			this.getQueryQRCodeInterval(code);
		});
	}

	componentWillUnmount() {
		clearTimeout(this.queryQrcodeTimer);
		this.queryQrcodeTimer = null;
	}

	insertQrcode(code) {
		let el = $(this.refs.qrcode);

		el.qrcode({
			text: code,
			width: 160,
			height: 160,
			render: "canvas"
		});
	}
	/**
	 * 检测用户是否已经扫码登录成功，若失败，2秒之后查询
	 */
	getQueryQRCodeInterval(code) {

		let queryQrcodePromise = this.getQueryQRCode(code);

		queryQrcodePromise.done(data => {
			if (!data) {
				this.queryQrcodeTimer = setTimeout(() => {
					this.getQueryQRCodeInterval(code);
				}, this.props.delay);
			} else {
				clearTimeout(this.queryQrcodeTimer);
				this.queryQrcodeTimer = null;
				
				// console.log('QrcodeLogin:', data);
				// 授权成功，真实用户
            	cache.setCache('isRegisterRealUser', true);

				$.channel.emit("loginSuccess", data);
			}
		});
	}

	getQRCode() {
		let defer = $.Deferred();
		const { Response } = codeCreatePb.TwoDimensionalCode.Create;

		let requestData = {
			service: "service", // java service name
			api: "/two/dimensional/code/create" // java api
		};

		pbajax.do(
			requestData,
			{},
			function(res) {
				let dataWrap = publicpb.Result.decode(res);
				let data = Response.decode(dataWrap.data.value);

				defer.resolve(data.randomCode);
			},
			() => {
				defer.reject();
			},
			() => {
				defer.reject();
			}
		);

		return defer.promise();
	}

	getQueryQRCode(code) {
		let self = this;
		let defer = $.Deferred();
		const { Request, Response } = codeQueryPb.TwoDimensionalCode.Query;
		
		let businessData = new Request({ randomCode: code, deviceId: "" });
		
		let requestData = {
			service: "service",
			api: "/two/dimensional/code/query" 
		};

		pbajax.do(
			requestData,
			businessData,
			function(res) {
				let dataWrap = publicpb.Result.decode(res);

				if (dataWrap.code == 4121) {
					defer.resolve(false);
				} else {
					let data = Response.decode(dataWrap.data.value);
					let userInfo = Object.assign({}, data.profile, self.parseData(data.profile));

					defer.resolve(userInfo);
				}
			},
			() => {
				defer.reject();
			},
			() => {
				defer.reject();
			}
		);

		return defer.promise();
	}

	/*
     * 解析数据
     */
    parseData(data) {
        let balance = data.balance || {};
        return {
            uid: this.longToString(data.uid), // 用户UID
            balance: {
                diamond: this.longToInt(balance.diamond),
                bill: this.longToInt(balance.bill),
                inBill: this.longToInt(balance.inBill),
                outDiamond: this.longToInt(balance.outDiamond)
            },
            exp: this.longToInt(data.exp), // 用户经验值
            currentExp: this.longToInt(data.currentExp), //当前级的经验值
            nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
            chatroomid: this.longToString(data.chatroomid),
            officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
        }
    }

    longToString(value) {
        return window.longToString(value);
    }

    longToInt(value) {
        value = this.longToString(value);

        return parseInt(value, 10) || 0;
    }

	render() {
		let tip = lang.template("打开Up直播<br/>扫一扫登录");
		tip = tip.replace('<br/>','&nbsp;&nbsp;');
		return (
			<div className="qrcode-login">
				<div className="qrcode-wrap">
					<div className="qrcode" ref="qrcode" />
				</div>
				<div className="tip" dangerouslySetInnerHTML={{ __html: tip }} />
			</div>
		);
	}
}

export default QrcodeLogin;



// WEBPACK FOOTER //
// ./js/component/qrcode-login/index.js